class Mixins extends React.Component {
  render() {
    return(
      <ul className="section__items--mixins">
        <Caret />
        <Clearfix />
        <GridColumn />
        <FontIcons />
        <HiddenElement />
        <HiddenText />
        <HoverTransition />
        <RespondTo />
        <Square />
        <Spinner />
        <Typography />
      </ul>
    )
  }
};
